import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firestoreConnect } from 'react-redux-firebase'
import { Redirect } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles';

// import mango from '../../assets/mango.png';
import poster from '../../assets/trollaa-jaipur.png';
import click from '../../assets/order-now.gif';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import AfterOrder from './AfterOrder';

const styles = {
  mainClickable: {
    textAlign: 'center',
    height: '100vh',
    width: '100vw',
    overflow: 'hidden',
    // background: 'url(./static/media/mango.849746f8.jpg) center center/cover',
    background: `url(${require('../../assets/mango.jpg')}) center center/cover`,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end'
  },
  main: {
    background: '#fff',
    minHeight: '100vh',
    width: '100wh'
  },
  mangoImg: {
    tectAlign: 'center'
  },
  img: {
    maxWidth: '100%',
    height: 'auto'
  },
  locate: {
    textAlign: 'center',
  },
  locateText: {
    color: '#f00'
  },
  click: {
    cursor: 'pointer',
    textAlign: 'center',
  },
  error: {
    color: '#f00',
    margin: 0,
    padding: '100px 10px 0',
    fontSize: 20
  },
  success: {
    color: '#00f',
  }
};

const themeStyles = theme => ({
  imgUpper: {
    height: 'auto',
    width: '80%',
    maxWidth: 400,
    cursor: 'pointer',
    marginBottom: 50,
    background: '#fff',
    borderRadius: 10,
    overflow: 'hidden'
    // [theme.breakpoints.down('sm')]: {
    //   paddingTop: '30px'
    // },
    // [theme.breakpoints.up('md')]: {
    //   maxWidth: '40%',
    //   paddingTop: '30px'
    // },
  },
});

class Dashboard extends Component {

  state = {
    latitude: null,
    longitude: null,
    error: null,
    distance: null,
    order: false
  }

  getLocation = () => {
    navigator.geolocation.getCurrentPosition((position) => {
      console.log("Latitude is :", position.coords.latitude);
      console.log("Longitude is :", position.coords.longitude);

      const dis = getDistance(26.89889, 75.73299, position.coords.latitude, position.coords.longitude, 'K');

      this.setState({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        distance: dis,
        error: null
      })

      // alert(dis)

    }, (error) => {
      console.log('error : ', error)
      // this.setState({
      //   latitude: null,
      //   longitude: null,
      //   error,
      //   distance: null
      // })
    });
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }

  handleSelectChange = (event) => {
    this.setState({
      quantity: event.target.value
    })
  };

  handleClose = () => {
    this.setState({
      selectOpen: false
    })
  };

  handleOpen = () => {
    this.setState({
      selectOpen: true
    })
  };

  saveDetails = () => {

    const { distance, name, mobileNo, deliveryAddress, anyMessage, selectOpen, quantity, latitude, longitude } = this.state

    if (!name) {
      alert('Please enter your name');
      return;
    }

    if (!mobileNo) {
      alert('Please enter your mobile no.');
      return;
    }

    if (mobileNo.toString().length != 10) {
      alert('Please enter valid mobile no.');
      return;
    }

    if (!deliveryAddress) {
      alert('Please enter delivery address');
      return;
    }

    if (!quantity) {
      alert('Please select quantity');
      return;
    }

    const { firestore } = this.props;
    firestore.add(
      { collection: 'orders' },
      { distance, name, mobileNo, deliveryAddress, anyMessage: (anyMessage || ''), quantity, latitude, longitude, createdAt: new Date() },
    )
      .then((success) => {
        this.setState({ order: true })
        // alert('Your order has been placed ! We will deliver in 24 Hour Max.');
        // this.setState({
        //   latitude: null,
        //   longitude: null,
        //   error: null,
        //   distance: null
        // })
        // window.location.reload();
      }, (err) => { },
      );
  };

  render() {
    const { distance, name, mobileNo, deliveryAddress, anyMessage, selectOpen, quantity, order } = this.state
    const { imgUpper } = this.props.classes

    if (order) {
      return <AfterOrder />
    }

    return (
      <div style={styles.main}>
        {
          (distance == null)
            ?
            <div onClick={this.getLocation} style={styles.mainClickable}>

              <div className={imgUpper}>
                <img style={styles.img} src={click} />
                <img style={styles.img} src={poster} />
              </div>

              {/* <div style={styles.locate}>
                <p style={styles.locateText}>FREE DELIVERY CHECKER</p>
                <img style={styles.img} src={locate} />
              </div> */}
              {/* <div onClick={this.getLocation} style={styles.click}>
                <img style={styles.img} src={click} />
              </div> */}
            </div>
            :
            (
              distance > 8
                ?
                <div style={{ textAlign: 'center', alignSelf: 'center' }}>
                  <p style={styles.error}>Sorry ! <br />
                    Your location is more then 08 km from us. We deliver same day in<br /> Vaishali Nagar + 08 KM Area.
                  </p>

                  <p style={styles.success}>
                    Call : <a href="callto:7296961836">7296961836</a> for more details.
                  </p>
                </div>
                :
                <div style={{ maxWidth: 500, width: '90%', margin: '0 auto', padding: '20px 0' }}>

                  <p style={{ textAlign: 'center', margin: 0 }}><strong>We deliver FREE in your area Please submit this form. We will deliver in 24 Hour Max.</strong></p>

                  <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="name">Name</InputLabel>
                    <Input
                      onChange={this.handleChange}
                      value={name}
                      id="name" name="name" autoComplete="text" />
                  </FormControl>

                  <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="mobileNo">Mobile No</InputLabel>
                    <Input
                      type="tel"
                      onChange={this.handleChange}
                      value={mobileNo}
                      id="mobileNo" name="mobileNo" autoComplete="text" />
                  </FormControl>

                  <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="deliveryAddress">Delivery Address</InputLabel>
                    <Input
                      onChange={this.handleChange}
                      value={deliveryAddress}
                      id="deliveryAddress" name="deliveryAddress" autoComplete="text" />
                  </FormControl>

                  <FormControl margin="normal" required fullWidth>
                    <InputLabel id="demo-controlled-open-select-label">Quantity</InputLabel>
                    <Select
                      labelId="demo-controlled-open-select-label"
                      id="demo-controlled-open-select"
                      open={selectOpen}
                      onClose={this.handleClose}
                      onOpen={this.handleOpen}
                      value={quantity}
                      onChange={this.handleSelectChange}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value={5}>05 kg </MenuItem>
                      <MenuItem value={10}>10kg</MenuItem>
                      <MenuItem value={15}>15 kg </MenuItem>
                      <MenuItem value={20}>20 kg </MenuItem>
                      <MenuItem value={25}>25 kg </MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="anyMessage">Any Message</InputLabel>
                    <Input
                      onChange={this.handleChange}
                      value={anyMessage}
                      multiline
                      id="anyMessage" name="anyMessage" autoComplete="text" />
                  </FormControl>

                  <div style={{ marginTop: 30, textAlign: 'center' }}>
                    <Button onClick={this.saveDetails} variant="contained" color="primary">
                      Order Now
                    </Button>
                    {/* <p>Message after order : Your order has been placed ! We will deliver in 24 Hour Max.</p> */}

                  </div>
                </div>
            )
        }

      </div>

    );
  }
}

const mapStateToProps = (state) => {
  return {}
}

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [])
)(withStyles(themeStyles)(Dashboard));


function getDistance(lat1, lon1, lat2, lon2, unit) {
  if ((lat1 == lat2) && (lon1 == lon2)) {
    return 0;
  }
  else {
    var radlat1 = Math.PI * lat1 / 180;
    var radlat2 = Math.PI * lat2 / 180;
    var theta = lon1 - lon2;
    var radtheta = Math.PI * theta / 180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = dist * 180 / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit == "K") { dist = dist * 1.609344 }
    if (unit == "N") { dist = dist * 0.8684 }
    return dist;
  }
}